import { Feature, FeatureCollection, LineString, Polygon } from 'geojson';
import { createRoad } from '../../api/geojson/road';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

export type RoadFeatureCollection = FeatureCollection<LineString, { HROAD: number, NAME: string, ROAD_CLASS: number, FC: number, LANES: string }>;
export type FurnitureFeatureCollection = FeatureCollection<LineString, { CHAIN: number, HROAD: number }>;
export type LaneDividerFeatureCollection = FeatureCollection<LineString, { HROAD: number, LANEDIV: number }>;
export type LanePolygonsFeatureCollection = FeatureCollection<Polygon, { HROAD: number, FeiJiDongC: number, Id: number }>;
export type SymbolPGFeatureCollection = FeatureCollection<Polygon, { HROAD: number, Id: number }>;
export type LaneAttributeFeatureCollection = FeatureCollection<LineString, { HROAD: number }>;


const EmptyLineStringFeatureCollection: FeatureCollection<LineString, any> = {
  type: 'FeatureCollection',
  features: [],
};

const EmptyPolygonFeatureCollection: FeatureCollection<Polygon, any> = {
  type: 'FeatureCollection',
  features: [],
};

export interface IRoadData {
  road: Feature<LineString>;
  furniture: FeatureCollection<LineString>;
  laneDivider: FeatureCollection<LineString>;
  lanePolygons: FeatureCollection<Polygon>;
  symbolPGPolygons: FeatureCollection<Polygon>;
  laneAttribute: FeatureCollection<LineString>;
}

export default class RoadLoader extends SingletonEventEmitterClass {
  public roads: IRoadData[] = [];

  private _road: RoadFeatureCollection = EmptyLineStringFeatureCollection;
  private _furniture: FurnitureFeatureCollection = EmptyLineStringFeatureCollection;
  private _laneDivider: LaneDividerFeatureCollection = EmptyLineStringFeatureCollection;
  private _lanePolygons: LanePolygonsFeatureCollection = EmptyPolygonFeatureCollection;
  private _symbolPGFeatureCollection: SymbolPGFeatureCollection = EmptyPolygonFeatureCollection;
  private _laneAttribute: LaneAttributeFeatureCollection = EmptyLineStringFeatureCollection;

  public get geojsonRoad() {
    return this._road;
  }

  public get geojsonFurniture() {
    return this._furniture;
  }

  public get geojsonLaneDivider() {
    return this._laneDivider;
  }

  public setData(road: RoadFeatureCollection, furniture: FurnitureFeatureCollection, laneDivider: LaneDividerFeatureCollection, lanePolygons: LanePolygonsFeatureCollection,symbolPGPolygons:SymbolPGFeatureCollection ,laneAttribute:LaneAttributeFeatureCollection) {
    this._road = road;
    this._furniture = furniture;
    this._laneDivider = laneDivider;
    this._lanePolygons = lanePolygons;
    this._symbolPGFeatureCollection = symbolPGPolygons;
    this._laneAttribute = laneAttribute;
    const roadMap: {
      [id: string]: IRoadData;
    } = {};
    road.features.forEach(feature => {
      roadMap[feature.properties.HROAD] = {
        road: feature,
        furniture: {
          type: 'FeatureCollection',
          features: [],
        },
        laneDivider: {
          type: 'FeatureCollection',
          features: [],
        },
        lanePolygons: {
          type: 'FeatureCollection',
          features: [],
        },
        symbolPGPolygons: {
          type: 'FeatureCollection',
          features: [],
        },
        laneAttribute: {
          type: 'FeatureCollection',
          features: [],
        },
      };
    });
    furniture.features.forEach(feature => {
      const data = roadMap[feature.properties.HROAD];
      if (data) {
        data.furniture.features.push(feature);
      }
    });
    laneDivider.features.forEach(feature => {
      const data = roadMap[feature.properties.HROAD];
      if (data) {
        data.laneDivider.features.push(feature);
      }
    });
    lanePolygons.features.forEach(feature => {
      const data = roadMap[feature.properties.HROAD];
      if (data) {
        data.lanePolygons.features.push(feature);
      }
    });
    symbolPGPolygons.features.forEach(feature => {
      const data = roadMap[feature.properties.HROAD];
      if (data) {
        data.symbolPGPolygons.features.push(feature);
      }
    });
    laneAttribute.features.forEach(feature => {
      const data = roadMap[feature.properties.HROAD];
      if (data) {
        data.laneAttribute.features.push(feature);
      }
    });

    this.roads = Object.keys(roadMap).map((id: string) => roadMap[id]);
    this._triggerUpdate();
  }

  public async publish() {
    // Publish
    const promises: any = [];
    this.roads.forEach(async (road: IRoadData, index: number) => {
      const reset = index === this.roads.length - 1 ? () => this.reset() : undefined;
      promises.push(await createRoad(road, index, () => this._percentUpdate(index + 1), reset));
    });
    await Promise.all(promises);
  }

  public reset() {
    this._road = EmptyLineStringFeatureCollection;
    this._furniture = EmptyLineStringFeatureCollection;
    this._laneDivider = EmptyLineStringFeatureCollection;
    this._lanePolygons = EmptyPolygonFeatureCollection;
    this._laneAttribute = EmptyLineStringFeatureCollection;
    this._symbolPGFeatureCollection = EmptyPolygonFeatureCollection;
    this.roads = [];
    this._triggerUpdate();
  }

  private _triggerUpdate() {
    this.emit('updated');
  }

  private _percentUpdate(percent: number) {
    this.emit('percent_updated', percent);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/RoadLoader.ts